import styled from 'styled-components';

export const TabTitle = styled.p`
  font-weight: 600;
  font-size: 18px;
  letter-spacing: -0.2px;
  opacity: 1;
`;

export const TabTitle1 = styled.p`
  display: flex;
  justify-content: center;
  font-weight: bold;
  font-size: 24px;
`;

export const ConfirmButtonsContainer = styled.p`
  display: flex;
  justify-content: center;
`;
